module.exports = __webpack_public_path__ + "static/img/2.3e79fc38.jpg";